import { render, staticRenderFns } from "./AInspectionPlanDetailStaff.vue?vue&type=template&id=8f1c1074&scoped=true"
import script from "./AInspectionPlanDetailStaff.vue?vue&type=script&lang=js"
export * from "./AInspectionPlanDetailStaff.vue?vue&type=script&lang=js"
import style0 from "./AInspectionPlanDetailStaff.vue?vue&type=style&index=0&id=8f1c1074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c1074",
  null
  
)

export default component.exports